import { ReactElement, useCallback } from "react";
import Loading from "components/Loading";
import DisplayError from "components/info/DisplayError";
import { createFetchContext } from "components/context/FetchContextFactory";
import { fetchAllUsers } from "../api";
import { UsersSearchResponse } from "../types";
import { AxiosResultDefaultError } from "api/request2";

interface UsersLoaderProps {
  children: (data: {
    users: UsersSearchResponse;
    refresh: () => Promise<void>;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  UsersSearchResponse,
  AxiosResultDefaultError
>();

export function useLeavesReviewUsersLoader() {
  return useFetch();
}

export default function LeavesReviewUsersLoader({
  children,
}: UsersLoaderProps) {
  const request = useCallback(async () => {
    return fetchAllUsers();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) return <Loading />;
          if (error)
            return (
              <DisplayError typeError={error.code} retryAction={refresh} />
            );
          return children({ users: data || [], refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
